<template>
  <div class="animated fadeIn">
    <SubHeaderSubmission/>
    <DataTable :editable="editable" :eventStatus="eventStatus" />
  </div>
</template>

<script>
import data from '../_data';
import SubHeaderSubmission from '../components/subHeaders/SubHeaderSubmission';
import DataTable from '../components/datatable/DataTable';
import consts from '../_consts';

export default {
  name: 'submitted',
  components: {
    SubHeaderSubmission,
    DataTable
  },
  data () {
    return {
      currentPage: 1,
      perPage: 5,
      totalRows: data.items.length,
      pageOptions: [
        { text: 5, value: 5 },
        { text: 10, value: 10 },
        { text: 15, value: 15 }
      ],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' },
      eventStatus: consts.eventStatus.submitted
    };
  },
  methods: {
    details (item, index, button) {
      this.modalDetails.data = JSON.stringify(item, null, 2);
      this.modalDetails.index = index;
      this.$root.$emit('show::modal', 'modal1', button);
    }
  },
  computed: {
    editable () {
      return localStorage.getItem(consts.LOCAL_STORE.role) === consts.USER_ROLE.eventManager;
    }
  }
};
</script>



// WEBPACK FOOTER //
// Submitted.vue?0c26a57a